export const slugify = (text: string) => {
  let result = text
    .toLowerCase()
    .replace(/[\s-]+/g, '_') // no spaces and dashes
    .replace(/[^a-z0-9_]/g, '') // only latin letter, digits and "_" are allowed
    .replace(/_{2,}/g, '_') // joins multiple "_"
    .trim();

  // erases leading "_"
  while (result.length > 0 && result[0] === '_') {
    result = result.slice(1);
  }

  // erases trailing "_"
  while (result.length > 0 && result[result.length - 1] === '_') {
    result = result.slice(0, result.length - 1);
  }

  // erases leading digits
  while (result.length > 0 && /^\d/.test(result)) {
    result = result.slice(1);
  }

  return result;
};
